import { FC, useState } from "react";
import TypeAhead from "../TypeAhead/TypeAheadString";
import { Item } from "../TypeAhead/types";
import { globalDebounceTime, Locale } from "../../setup/locale";

const GenericTypeAhead: FC<{
    disabled?: boolean;
    label?: string;
    current: string;
    list: Record<string, string>;
    onChange: (id: string | null) => void;
    useOffsetY?: boolean;
}> = ({
    disabled,
    label,
    current,
    list,
    onChange,
    useOffsetY = false
}) =>
    {
        const [openList, setOpenList] = useState(false);

        const fullList: Item<{ id: string; label: string; }>[] = Object.entries(list).map(([id, label]) => ({
            key: "label",
            data: { id, label }
        }));

        return <TypeAhead<{ id: string; label: string; }>
            useOffsetY={useOffsetY}
            id="generic-type-ahead"
            text={(label ?? "") as Locale}
            disabled={disabled}
            debounce={globalDebounceTime}
            value={current}
            list={openList ? fullList : []}
            onFilter={async (value) =>
            {
                const filtered = fullList.filter(({ data }) =>
                    data.label.toLowerCase().includes(value.toLowerCase())
                );
                return filtered;
            }}
            onChange={(data) =>
            {
                const id = data.id;
                onChange(id || null);
            }}
            onFocus={() => setOpenList(true)}
            onIconClick={() => setOpenList(true)}
        />;
    };

export default GenericTypeAhead;
